export const ERROR_CODES = {
  // -32000 to -32019: Auth-related errors
  // -32020 to -32039: Lead-related errors
  // -32040 to -32049: Master-related errors
  // -32050 to -32069: User-related errorserrors
  // -32090 to -32099: Minio-related errors
  // -32100 to -32109: Mailer-related errors
  ACCOUNT_DEACTIVATED: -32059,
  ACCOUNT_LOCKED: -32015,
  ACCOUNT_REGISTRATION_DECLINED: -32011,
  ACCOUNT_REGISTRATION_PENDING: -32010,
  ACCOUNT_VERIFICATION_EXPIRED: -32014,
  ACCOUNT_VERIFICATION_INVALID: -32013,
  ACCOUNT_VERIFICATION_PENDING: -32012,
  ADD_ONS_DUPLICATE_ERROR: -32487,
  CONTACT_TYPE_UPDATE_ERROR: -32110,
  DATA_FETCH_ERROR: -32604,
  DUPCHECK_ENTITY_NOT_FOUND: -32020,
  EMAIL_ALREADY_EXISTS: -32000,
  EXTERNAL_API_KEY_CREATE_ERROR: -32140,
  INTERNAL_ERROR: -32603,
  INVALID_ARGUMENTS: -32602,
  INVALID_BRANCH: -32005,
  INVALID_JSON: -2,
  INVALID_LOGIN: -32003,
  INVALID_MASTER: -32001,
  INVALID_METHOD: -32601,
  INVALID_PERMISSION_TO_TASK: -32419,
  INVALID_PERMISSION: -32008,
  INVALID_REQUEST: -32600,
  INVALID_TOKEN: -32009,
  INVALID_USER_RESET_PASSWORD_ERROR: -32062,
  LDAP_AUTH_UNAVAILABLE: -32161,
  LDAP_LOGIN_DISABLED: -32160,
  LEAD_CAMPAIGN_DUPLICATE_ERROR: -32046,
  LEAD_IMPORT_INVALID_FORMAT: -32218,
  LEAD_SOURCE_DUPLICATE_ERROR: -32026,
  LEAD_SOURCE_TYPE_DUPLICATE_ERROR: -32041,
  MAILER_SEND_ERROR: -32100,
  MASTER_UPDATE_ERROR: -32048,
  MINIO_BUCKET_ALREADY_EXISTS: -32090,
  MINIO_BUCKET_NOT_FOUND: -32091,
  MINIO_CREATE_BUCKET_ERROR: -32093,
  MINIO_DELETE_BUCKET_ERROR: -32094,
  MINIO_DELETE_FILE_ERROR: -32096,
  MINIO_FETCH_ERROR: -32097,
  MINIO_FILE_NOT_FOUND: -32092,
  MINIO_UPLOAD_ERROR: -32095,
  NETWORK_ERROR: -1,
  OPPORTUNITY_REASSIGN_MISSING_OWNER_ID_ERROR: -323411,
  PARSE_ERROR: -32700,
  PRICING_DUPLICATE_ERROR: -32417,
  PRODUCT_BUNDLE_DUPLICATE_ERROR: -32520,
  PRODUCT_DUPLICATE_ERROR: -32413,
  SALES_OBJECTIVE_DUPLICATE_ERROR: -32435,
  PRODUCT_GROUP_NAME_DUPLICATE: -32398,
  PRODUCT_SERVICE_DUPLICATE_ERROR: -32505,
  PROFILE_NAME_DUPLICATE: -32319,
  TEAM_DELETE_ERROR: -32302,
  TEAM_NAME_DUPLICATE: -32300,
  TEAM_NOT_FOUND: -32299,
  TOKEN_IS_EXPIRED: -32007,
  TOKEN_NOT_REVOKED: -32006,
  UNAUTHORIZED: -32002,
  USER_BRANCH_REQUIRED: -32053,
  USER_CREATE_ERROR: -32050,
  USER_GROUP_CREATE_ERROR: -32054,
  USER_GROUP_DUPLICATE_ERROR: -32058,
  USER_RESEND_VERIFCATION_CODE_ERROR: -32052,
  USER_UPDATE_ERROR: -32051,
}

export const ERROR_MESSAGES = {
  SIGNATURE_VERIFICATION_FAILED: 'Signature verification failed',
}
